import { render, staticRenderFns } from "./PostReplySearch.vue?vue&type=template&id=22f3bb92&"
import script from "./PostReplySearch.vue?vue&type=script&lang=js&"
export * from "./PostReplySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports